import { compose } from 'recompose';
import { connect } from 'react-redux';

import { isLoggedInSelector } from '../redux/auth/selectors';

export const withLoggedIn = compose(
  connect(state => ({ isLoggedIn: isLoggedInSelector(state) })),
);



// WEBPACK FOOTER //
// ./src/hocs/withLoggedIn.js